/**
 * Kopf der Projektseite (Plan Projekt-Tracking, Etappe 2; Entwurf „Kontor
 * Projektkopf"): Kopfzeile, Karte „Jetzt" mit Phase, Stand und Aufgaben, darunter
 * eine Zahlenzeile. Nur das Aktuelle — der Rest steht in den Sektionen darunter.
 */
import { useState } from "react";
import { fehlerText } from "@vimaana/ui";

import AngebotZusammenhang from "./AngebotZusammenhang";
import KopfJetzt from "./KopfJetzt";
import KopfStand from "./KopfStand";
import KopfZahlen from "./KopfZahlen";
import KopfZeile from "./KopfZeile";
import NotizenBlock from "../notizen/NotizenBlock";
import { useProjektLage } from "../../hooks/useProjektLage";
import type { ProjektAuftragswert, ProjektDetail } from "../../lib/types";
import "@vimaana/ui/kopf";

type Props = {
  projektId: string;
  d: ProjektDetail | undefined;
  wert: ProjektAuftragswert | undefined;
  gewinn: number;
  netto: number;
  /** Gewinn je Inhaberstunde und die Stunden dazu (aus den Kennzahlen). */
  stundenlohn?: { betrag: number; inhaberStunden: number; helferStunden: number };
  gewinnWeg?: string;
  onStammdaten: () => void;
  /** Zwischen Karte und Zahlen, z. B. der Hinweis nach dem Anlegen aus einem Leed. */
  children?: React.ReactNode;
};

export default function ProjektKopf({ projektId, d, wert, gewinn, netto, stundenlohn, gewinnWeg, onStammdaten, children }: Props) {
  const lage = useProjektLage(projektId);
  // „Vor Ort bar bezahlt": angestoßen im „⋯"-Menü, der Dialog steht in der Karte „Jetzt".
  const [barOffen, setBarOffen] = useState(false);

  return (
    <div className="pk">
      <KopfZeile projektId={projektId} d={d} lage={lage.data} onStammdaten={onStammdaten} onBarBezahlt={() => setBarOffen(true)} />
      {children}
      <AngebotZusammenhang wert={wert} />
      {lage.data ? (
        <KopfJetzt projektId={projektId} kundeId={d?.kunde_id || ""} status={lage.data.status || d?.status || ""} lage={lage.data} barOffen={barOffen} onBarOffen={setBarOffen} />
      ) : (
        /* Ohne Lage (lädt oder Fehler) bleiben Stand und Aufgaben bedienbar. */
        <section className="pk-jetzt vg-anker" id="sek-stand" aria-label="Jetzt" aria-busy={lage.isPending}>
          {lage.isError && <p className="pk-fehler">Phase nicht verfügbar: {fehlerText(lage.error)}</p>}
          <div className="pk-raster">
            <KopfStand projektId={projektId} />
            <div className="pk-aufgaben">
              <div className="pk-spaltenkopf"><span className="pk-eyebrow">Aufgaben</span></div>
              <NotizenBlock bezug={{ projekt_id: projektId }} ohneKopf platzhalter="Aufgabe hinzufügen …" />
            </div>
          </div>
        </section>
      )}
      <KopfZahlen wert={wert} gewinn={gewinn} netto={netto} stundenlohn={stundenlohn} gewinnWeg={gewinnWeg} />
    </div>
  );
}
